(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-textarea"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    function toggleHtml(element, text1, text2) {
      if (element.innerHTML.trim() === text1.trim()) {
        element.innerHTML = text2;
      } else {
        element.innerHTML = text1;
      }
    }

    if (window.innerWidth < 1199) {
      var content = document.querySelector('[data-toggle-text]');
      var contentHeight = content.offsetHeight;

      if (contentHeight > 250) {
        content.classList.add('faded');
      }

      document.querySelectorAll('.toggle-text').forEach(function (toggle) {
        toggle.addEventListener('click', function () {
          var readMoreText = this.getAttribute('data-read-more');
          var readLessText = this.getAttribute('data-read-less');
          var toggleTextHtml = readLessText + '<i class="fa fa-angle-up"></i>';

          if (this.innerHTML.includes('fa-angle-down')) {
            toggleTextHtml = readLessText + '<i class="fa fa-angle-up"></i>';
          } else {
            toggleTextHtml = readMoreText + '<i class="fa fa-angle-down"></i>';
          }

          this.closest('[data-toggle-text]').querySelector('.text').classList.toggle('active');

          toggleHtml(
            this,
            readLessText + '<i class="fa fa-angle-up"></i>',
            readMoreText + '<i class="fa fa-angle-down"></i>'
          );
        });
      });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
